import {createStore, Store, useStore as baseUseStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {InjectionKey} from 'vue'
import {state, State} from './state'
import mutations from './mutation'
import actions from './actions'


export const key: InjectionKey<Store<State>> = Symbol()

export const store = createStore({
    state,
    mutations,
    actions,
    modules: {},
    plugins: [createPersistedState({
        storage:window.sessionStorage
    })]
})

export function useStore() {
    return baseUseStore(key)
}
